import type { ScreenSchema } from './types';

/**
 * Schema for the `big-quote` template.
 *
 * The template renders via +wrapper (not +content), so no standard uc-content
 * block is used. The audible fields are:
 *   - `text`   — the quote body
 *
 * `big-quote` screens may also include `screen.templates[]` — these are
 * nested uc-screen instances that each manage their own intro audio via their
 * own sectionActive watcher (they are not suppressed here).
 */
const bigQuoteSchema: ScreenSchema = {
  template: 'big-quote',
  slots: {
    intro: {
      parts: [{ field: 'text' }]
    }
  }
};

export default bigQuoteSchema;
